module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top navbar-app"
  }, [_c('div', {
    staticClass: "nav-default"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-1"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse navbar-right"
  }, [_c('ul', {
    staticClass: "nav navbar-nav fontColor"
  }, [_vm._l((_vm.modules), function(module, index) {
    return _c('li', {
      key: index,
      class: {
        activeUnderline: _vm.activeTo == module.to
      },
      on: {
        "click": function($event) {
          return _vm.selected(module.to)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": module.to
      }
    }, [_vm._v(_vm._s(_vm.$t(("header." + (module.name)))))])], 1)
  }), _vm._v(" "), _c('li', {
    staticClass: "portals-title-page"
  }, [_c('a', {
    attrs: {
      "href": "javascript:0;"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.others")))]), _vm._v(" "), _c('div', {
    staticClass: "portal-subset-hide"
  }), _vm._v(" "), _c('ul', {
    staticClass: "portal-subset-page"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://portal.tintinhealth.com/ysmh"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.other_option1")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://ttapi.tintinhealth.com:9000/ddmanager"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.other_option2")))])])])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "###"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../src/assets/images/footer-left.png"),
      "alt": "Steer logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6c75036","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = 276
// module chunks = 1